import React from "react";
import { Link } from "react-router-dom";
import "../dashboard/css/category2.css";
import { CATEGORY_CONFIG } from "../../data/categoryConfig";

// Images - mapped to services
const SERVICE_IMAGES = {
  'banquet-halls': require("../dashboard/assets/banquethalls.avif"),
  'bridal-requisite': require("../dashboard/assets/bridalrequisite.webp"),
  'caterers': require("../dashboard/assets/caterers.avif"),
  'beauty-spa': require("../dashboard/assets/beautyparlours.jpg"),
  'spa-massage': require("../dashboard/assets/spamassages.webp"),
  'salons': require("../dashboard/assets/salons.jpg"),
  'ac-service': require("../dashboard/assets/acservice.jpg"),
  'car-service': require("../dashboard/assets/carservice.webp"),
  'bike-service': require("../dashboard/assets/bikeservice.jpg"),
  'movies': require("../dashboard/assets/movies.jpg"),
  'grocery': require("../dashboard/assets/grocery.jpg"),
  'electricians': require("../dashboard/assets/electricians.jpg")
};

const Category2 = () => {
  const CATEGORY_COLORS = {
    'wedding-requisites': "linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)",
    'beauty-spa': "linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)",
    'repairs-services': "linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%)",
    'daily-needs': "linear-gradient(135deg, #f6d365 0%, #fda085 100%)"
  };

  return (
    <div className="category2-wrapper">
      {CATEGORY_CONFIG.map((category) => (
        <div
          key={category.id}
          className="category2-section"
          style={{ backgroundImage: CATEGORY_COLORS[category.id] }}
        >
          <h3 className="category2-title">{category.title}</h3>
          <div className="category2-grid">
            {category.services.map((service) => (
              <Link 
                key={service.slug} 
                to={`/category/${service.slug}`}
                className="category2-card-link"
              >
                <div className="category2-card">
                  <div className="category2-img-wrap">
                    <img 
                      src={SERVICE_IMAGES[service.slug]} 
                      alt={service.name} 
                    />
                  </div>
                  <p className="category2-label">{service.name}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Category2;